import React from 'react'
import { Howl } from 'howler'

import { DataContext } from "./../../context/DataContext";

import './soundstrato.scss'

import { ReactComponent as Play } from './../../assets/play.svg';
import { ReactComponent as Pause } from './../../assets/pause.svg';
import posterPlaceholder from './../../assets/poster-placeholder.jpg'

export const SoundStrato = React.memo( () => {
    const options = React.useContext( DataContext ).options

    const soundstrato = React.useRef( options && options.acf.soundstrato[ Math.floor( Math.random() * options.acf.soundstrato.length ) ] )
    const video = React.useRef()
    const tracks = React.useRef()
    const [ currentTrack, setCurrentTrack ] = React.useState( [] )

    const toggleTrack = ( index ) => {
        soundstrato.current.allow_simultaneous
            ? !currentTrack.includes( index )
                ? setCurrentTrack( [ ...currentTrack, index ] )
                : setCurrentTrack( currentTrack.filter( track => track !== index ) )
            : !currentTrack.includes( index )
                ? setCurrentTrack( [ index ] )
                : setCurrentTrack( [] )

        !soundstrato.current.allow_simultaneous
            && tracks.current.map( ( track, i ) => i !== index && track.pause() )

        tracks.current[ index ].playing() 
            ? tracks.current[ index ].pause() 
            : play( index )
    }

    const play = ( index ) => {
        video.current.currentTime = soundstrato.current.force_video_restart ? 0 : video.current.currentTime
        tracks.current[ index ].seek( video.current.currentTime )
        tracks.current[ index ].play()
    }

    const handleEnd = () => {
        video.current.currentTime = 0
        setCurrentTrack( [] )
    }

    React.useLayoutEffect( () => {
        const pause = () => {
            video.current.pause()
            video.current.currentTime = soundstrato.current.force_video_restart ? 0 : video.current.currentTime
        }

        currentTrack.length > 0 
            ? video.current.play()
            : pause()
    }, [ currentTrack ] )

    React.useEffect( () => {
        tracks.current = soundstrato.current.audio.map( audio => new Howl( { src: audio.file.url, html5: true, preload: true } ) )
        
        return () => {
            tracks.current.map( track => track.stop() )
        }
    }, [] )

    return (
        <div className={ `soundstrato` } >
            <div className={ `soundstrato-inner` } >
                <div className={ `soundstrato-frame` } >
                    <video onEnded={ handleEnd } ref={ video } poster={ soundstrato.current.video.poster ? soundstrato.current.video.poster.sizes.large : posterPlaceholder } playsInline muted={ true } nocontrols={ true.toString() } >
                        <source src={ soundstrato.current.video.file.url } type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div className={ `soundstrato-controls` } >
                    {
                        soundstrato.current.audio && soundstrato.current.audio.length > 0 && soundstrato.current.audio.map( ( audio, index ) => (
                            <React.Fragment key={ index }>
                                <button onClick={ () => toggleTrack( index ) } className={ `soundstrato-controls-button` } >
                                    {
                                        currentTrack.includes( index )
                                            ? <Pause />
                                            : <Play />
                                    }
                                </button>
                            </React.Fragment>
                        ) )
                    } 
                </div>
            </div>
        </div>
    )
} )